function oRequest_APIEngine(engine) {
  this.engine = engine;
}

oRequest_APIEngine.prototype = {
  get: function (url, callback) {
    let o = this;
    this.engine.request.security.auth.get(url, function (auth_url) {
      o.engine.request.getAjax("GET", "json", auth_url, true, null, callback);
    });
  },
  post: function (url, data, callback) {
    let o = this;
    this.engine.request.security.auth.get(url, function (auth_url) {
      o.engine.request.getAjax("POST", "json", auth_url, true, data, callback);
      // o.logger("post", data);
    });
  },
  // post方式请求外部地址，后续考虑增加 type 区别 get 和 post
  open: function (url, data, callback) {
    this.engine.request.getAjax("POST", "json", url, true, data, callback);
  },
  upload: function (data, beforeCallback, completedCallback) {
    let o = this;
    this.engine.request.security.auth.get("/Octopus/Engine/Upload", function (auth_url) {
      o.engine.request.getUpload(auth_url, data, beforeCallback, completedCallback);
    });
  },
  export: function (source, callback) {
    // alert(JSON.stringify(data));
    let o = this;
    this.engine.request.security.auth.get("/Octopus/Engine/Export", function (auth_url) {
      o.engine.request.getExport(auth_url, source, callback);
    });
  },
  download: function (file, callback) {
    // alert(JSON.stringify(data));
    let o = this;
    this.engine.request.security.auth.get("/Octopus/Engine/Download", function (auth_url) {
      o.engine.request.getDownload(auth_url, file, callback);
    });
  },
  // 写入日志
  logger: function (type, data) {
    let PageData = this.engine.router.registerMap;
    let o = this;
    let url = location;

    let pageData = PageData.get(url.pathname);

    // 如果是打开页面，则直接保存日志
    if (type == "open") {
      // 覆盖，从路由注册集合中获取当前页面信息，注意本集合只记录当前页面及在当前页面打开的页面路由，并不是全局的。
      pageData = PageData.get(data.path);
      // console.warn(PageData.getValues());
      // console.warn(data.path + "," + PageData.get(data.path).ID);
      // 写入日志
      this.saveOperation(pageData, "执行了【访问】操作。");
    }
    // 创建事件 - 在ItemEngine控件的Create事件中增加这个函数调用即可。
    else if (type == "create") {
      this.saveOperation(pageData, "执行了【创建】操作，数据源ID："
        + data.id + "，主键值：" + data.value + "。");
    }
    // 修改
    else if (type == "modify") {
      // console.warn(data);
      this.saveOperation(pageData, "执行了【修改】操作，数据源ID："
        + data.id + "，主键值：" + data.value + "。");
    }
    // 搜索
    else if (type == "search") {
      this.saveOperation(pageData, "执行了【查询】操作，查询内容："
        + data.displayName + " " + data.searchKey + " '" + data.searchValue + "'。");
    }
    // 上传文件
    else if (type == "upload") {
      //

      //
    } else {

      console.warn(o.engine.router.registerMap.getValues());
      console.warn(url);
      // console.warn(o.engine.router.getter().options.routes);
    }

  },
  // 保存操作,
  saveOperation: function (pageData, content) {
    // console.warn(pageData);
    // console.warn(content);

    let o = this;
    this.engine.request.api.post("/Octopus/Engine/Item", {
        id: 21,
        type: "CREATE",
        cellData: [
          {name: "SystemID", defaultValue: pageData.SystemID},	// 系统
          {name: "MenuID", defaultValue: pageData.ID},	// MenuID
          {name: "Module", defaultValue: pageData.Module},	// Module
          {name: "IPAddress", defaultValue: pageData.IPAddress},	// IP地址
          {name: "Content", defaultValue: content},	// 操作内容
          {name: "OperationUserID", defaultValue: this.engine.passport.id},	// 操作人
        ]
      },
      // 处理回调事件，通过分析data.status.code的状态来实现。
      function (data) {
        if (data.status.code == 200) {

          //
        } else {
          o.engine.tips.error(data);
        }
      });
  }
};

export {
  oRequest_APIEngine
}





// WEBPACK FOOTER //
// ./src/assets/octopus/engine/request_api.js